// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__slPHD","details":"styles_details__7IDqt"};